import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExameNaturezaDto } from 'src/app/dtos/exames/exame-natureza-dto';
import { ExameNaturezaService } from 'src/app/servicos/exame-natureza.service';
import { ModalPesquisaService } from '../base-pesquisa/modal-pesquisa.service';

@Component({
  selector: 'app-exame-natureza-pesquisa',
  templateUrl: './exame-natureza-pesquisa.component.html',
  styleUrls: ['./exame-natureza-pesquisa.component.less'],
  providers: [ModalPesquisaService]
})
export class ExameNaturezaPesquisaComponent implements OnInit {

  toolbarItens: Object[] = ['Search'];

  @Output()
  registroSelecionado: EventEmitter<ExameNaturezaDto> = new EventEmitter<ExameNaturezaDto>();
  
  registros: Object | null = null;

  apenasEsocial: boolean = true;

  @Input()
  tudo: boolean = false;

  constructor(private modalServico: ModalPesquisaService, 
    private exameNaturezaService: ExameNaturezaService) { }

  ngOnInit(): void {
    
  }

  selecionado(registro: ExameNaturezaDto) {
    this.registroSelecionado.next(registro);
  }

  abrirTelaCheia() {
    this.modalServico.abrirTelaCheia();
    this.atualizar();
  }

  fechar() {
    this.modalServico.fechar();
  }

  atualizar() {
    this.exameNaturezaService
    .listarNaturezas(this.apenasEsocial, this.tudo)
    .subscribe((naturezas) => {
      this.registros = naturezas;
    })
  }

}
